import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function LegalPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState({ state: "idle", message: "" }); // idle | sending | success | error

  async function onSubmit(e) {
    e.preventDefault();

    setStatus({ state: "sending", message: "" });

    try {
      const res = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: form.name?.trim() || null,
          email: form.email.trim(),
          message: form.message.trim(),
        }),
      });

      if (!res.ok) {
  const txt = await res.text().catch(() => "");
  // FastAPI renvoie souvent {"detail":"..."} → on essaie de l’extraire
  let detail = "";
  try {
    const parsed = JSON.parse(txt);
    detail = parsed?.detail ? String(parsed.detail) : "";
  } catch {
    detail = txt ? String(txt) : "";
  }

  setStatus({
    state: "error",
    message: detail || "Erreur lors de l’envoi. Réessaie plus tard.",
  });
  return;
}

      setStatus({ state: "success", message: "Message envoyé." });
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      setStatus({
        state: "error",
        message: "Erreur réseau. Vérifie ta connexion et réessaie.",
      });
    }
  }

  return (
    <div className="min-h-screen bg-[#0b0b0c] text-white px-4 py-6">
      <div className="mx-auto w-full max-w-2xl space-y-6">
        <button
          onClick={() => navigate("/")}
          className="flex items-center gap-1.5 text-sm text-white/50 hover:text-white/90 transition-colors"
        >
          ← Retour
        </button>
        <h1 className="heading text-2xl">Mentions légales – UrbSex</h1>

        <section className="space-y-2">
          <h2 className="font-semibold">Éditeur</h2>
          <p className="text-sm text-white/80 leading-relaxed">
            Digital Architech (Projet personnel)
            <br />
            Paris, France
            <br />
            Contact : via le formulaire de contact
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="font-semibold">Hébergement</h2>
          <p className="text-sm text-white/80 leading-relaxed">
            Hébergeur : Hetzner Online GmbH
            <br />
            Industriestr. 25
            <br />
            91710 Gunzenhausen
            <br />
            Allemagne
            <br />
            <a
              href="https://www.hetzner.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-amber-400 hover:underline"
            >
              https://www.hetzner.com
            </a>
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="font-semibold">Responsabilité</h2>
          <p className="text-sm text-white/80 leading-relaxed">
            UrbSex est une plateforme communautaire.
            <br />
            Les contenus publiés par les utilisateurs relèvent de leur responsabilité.
            <br />
            Tout contenu illicite peut être signalé sur chaque fiche et via le formulaire de contact.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="font-semibold">Données collectées</h2>
          <p className="text-sm text-white/80 leading-relaxed">
            Email, pseudo, contenus publiés, logs techniques. Finalités : gestion du compte, sécurité,
            modération, amélioration du service. Les données de compte sont conservées jusqu'à suppression
            du compte. Les logs techniques sont conservés pour une durée limitée, au maximum 30 jours.
            Le traitement est fondé sur l'intérêt légitime de l'éditeur (sécurité, lutte contre les abus)
            et sur le consentement de l'utilisateur lors de l'inscription.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="font-semibold">Cookies et stockage local</h2>
          <p className="text-sm text-white/80 leading-relaxed">
            UrbSex n'utilise aucun cookie de traçage ni d'analytics. Seules deux
            données sont stockées localement dans votre navigateur : votre
            préférence de vérification d'âge et votre token d'authentification.
            Ces données sont strictement nécessaires au fonctionnement de
            l'application et ne sont jamais transmises à des tiers.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="font-semibold">Vos droits (RGPD)</h2>
          <p className="text-sm text-white/80 leading-relaxed">
            Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression
            de vos données. Pour exercer ces droits, utilisez le formulaire de contact.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="font-semibold">Formulaire de contact</h2>

          <form
            onSubmit={onSubmit}
            className="rounded-xl border border-white/10 bg-white/5 p-4 space-y-3"
          >
            <div className="space-y-2">
              <label className="text-xs text-white/60">Nom (optionnel)</label>
              <input
                type="text"
                value={form.name}
                onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
                className="w-full rounded-lg bg-zinc-900/60 border border-white/10 px-3 py-2 text-sm text-white placeholder:text-white/30 focus:outline-none focus:border-amber-500/60"
                placeholder="Ton nom"
                autoComplete="name"
              />
            </div>

            <div className="space-y-2">
              <label className="text-xs text-white/60">Email *</label>
              <input
                type="email"
                required
                value={form.email}
                onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
                className="w-full rounded-lg bg-zinc-900/60 border border-white/10 px-3 py-2 text-sm text-white placeholder:text-white/30 focus:outline-none focus:border-amber-500/60"
                placeholder="ton@email.com"
                autoComplete="email"
              />
            </div>

            <div className="space-y-2">
              <label className="text-xs text-white/60">Message *</label>
              <textarea
                required
                rows={5}
                value={form.message}
                onChange={(e) => setForm((f) => ({ ...f, message: e.target.value }))}
                className="w-full rounded-lg bg-zinc-900/60 border border-white/10 px-3 py-2 text-sm text-white placeholder:text-white/30 focus:outline-none focus:border-amber-500/60"
                placeholder="Ton message..."
              />
            </div>

            <div className="flex items-center gap-3">
              <button
                type="submit"
                disabled={status.state === "sending"}
                className="rounded-lg bg-amber-500 px-4 py-2 text-sm font-semibold text-black hover:bg-amber-400 disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {status.state === "sending" ? "Envoi..." : "Envoyer"}
              </button>

              {status.state === "success" && (
                <span className="text-sm text-emerald-300">{status.message}</span>
              )}
              {status.state === "error" && (
                <span className="text-sm text-red-300">{status.message}</span>
              )}
            </div>

          </form>
        </section>
      </div>
    </div>
  );
}